/* eslint-disable array-callback-return */
/* eslint-disable no-else-return */
/* eslint-disable no-restricted-globals */
/* eslint-disable consistent-return */
/* eslint-disable dot-notation */
/* eslint-disable radix */
/* eslint-disable default-case */
/* eslint-disable no-console */
/* eslint-disable no-restricted-syntax */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useState, useEffect } from 'react'
import { useStaticQuery, graphql, navigate } from "gatsby"
import { v4 } from 'uuid'

// Images
import blueCheck from 'img/blue_check.svg'
import stars from 'img/stars.svg'

// CSS
import theme from 'styles/theme'
import { H2, P, Content, Image } from 'components/StyledComponents'
import "react-datepicker/dist/react-datepicker.css";

// Third Party
import _ from 'lodash'
import Select from 'react-select'
import styled from 'styled-components'
import parse from 'html-react-parser'
import DatePicker from 'react-datepicker'

// Utilities
import { chunkArray, calculateColumn } from "../../utils"

const Label = styled.label``

const Input = styled.input``

const Textarea = styled.textarea``

const StyledDatePicker = styled(DatePicker)`
  width: 100%;
  padding: 10px 10px;
  margin: 10px 0px 10px;
  border-radius: 3px;
  border: solid 0.5px #979797;
  ::placeholder {
    color: #cdcdcd;
  }
`

const CheckBoxes = styled.div`
  ${props => props.boolCheck ? `
    flex: 0 0 50%;
    max-width: 50%;
  ` : `
    flex: 0 0 33%;
    max-width: 33%;
  `}

  display: flex;

  ${Input} {
    flex: 0 0 5%;
    max-width: 5%;
    margin-right: 5px;
  }

  ${Label} {
    flex: 0 0 95%;
    max-width: 95%;
    font-size: 14px !important;
    font-weight: 400 !important;
    display: inline;
    color: ${theme.colorTextMain} !important;
    margin-left: 5px;
    margin-top: 2px !important;
    margin-bottom: 3px !important;
  }
`

const RadioButtons = styled.div`
  flex: 0 0 50%;
  max-width: 50%;
  display: flex;

  ${Input} {
    flex: 0 0 20%;
    max-width: 20%;
    margin-right: 5px;
  }

  ${Label} {
    flex: 0 0 80%;
    max-width: 80%;
    font-size: 14px !important;
    font-weight: 400 !important;
    display: inline;
    color: ${theme.colorTextMain} !important;
    padding-left: 5px;
    padding-top: 2px;
    margin-top: 2px !important;
    margin-bottom: 3px !important;
  }

  @media (max-width: 991px) {
    ${Label} {
      padding-top: 0px;
    }
  }
`

const FormButton = styled.button`
  margin-left: auto;
  margin-right: auto;
  border-radius: 3px;
  padding: 15px 60px 15px;
  border: none;
  outline: none;
  text-decoration: none;
  -webkit-appearance: none;
  -moz-appearance: none;
`

const FormFooter = styled.div`
  display: flex;
`

const FormUpload = styled.div`
`

const FormSelect = styled.div`
`

const FormGroup = styled.div`
  ${Label} {
    display: block;
    font-size: 18px;
    line-height: 30px;
    color: #111111;
    font-weight: 800;
    margin-top: 20px;
    margin-bottom: 5px;
  }

  ${Input} {
    font-size: 18px;
    border-radius: 3px;
    border: solid 0.5px #979797;
    width: 100%;
    padding: 10px 10px;
    margin: 10px 0px 10px;
    outline: none;
    ::placeholder {
      color: #cdcdcd;
    }
  }

  ${Textarea} {
    font-size: 18px;
    border-radius: 3px;
    border: solid 0.5px #979797;
    width: 100%;
    padding: 5px 10px;
    min-height: 200px;
    margin: 10px 0px 10px;
    outline: none;
    ::placeholder {
      color: #cdcdcd;
    }
  }

  .achternaam {
    margin-top: 30px;

    @media (max-width: 991px) {
      margin-top: 0px;
    }
  }
`

const Form = styled.form`
  z-index: 20;
  position: relative;

  .kenteken-wrapper {
    position: relative;
    display: flex;
    justify-content: flex-start;
    max-width: fit-content;
    border-radius: 3px;
    background-color: transparent;

    .inner-shadow {
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      z-index: 1;
      box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.4);
      border-radius: 3px;
      pointer-events: none;
    }
    
    .blue-part {
      background-color: #0073B5;
      min-width: 40px;
      height: 47.73px;
      margin: 0;
      border-top-left-radius: 3px;
      border-bottom-left-radius: 3px;
      display: flex;
      justify-content: center;
      align-items: flex-end;
      color: #ffffff;
      position: relative;

      img {
        left: 0;
        right: 0;
        top: 5px;
        margin-left: auto;
        margin-right: auto;
        height: 20px;
        width: 20px;
        z-index: 10;
      }
    }

    .kentekenplaat {
      margin: 0 !important;
      max-width: 320px;
      border: none;
      background-color: #ffc70d;
      text-shadow: none;
      text-align: center;
      margin-bottom: 60px;
      position: relative;
      border-top-left-radius: 0px;
      border-bottom-left-radius: 0px;

      font-weight: 900;
      text-transform: uppercase;
      font-size: 26px;
    }
  }
`

const Preview = styled.div`
  position: relative; 

  ::before {
    right: 100%;
    top: 70px;
    border: solid transparent;
    content: " ";
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
    border-right-color: ${theme.colorSecondary};
    border-width: 30px;
    margin-top: -30px;
  }

  @media (max-width: 991px) {
    margin-top: 70px;

    ::before {
      border-right-color: transparent;
      border-bottom-color: ${theme.colorSecondary};
      bottom: 100%;
      left: 15%;
      top: auto;
      right: auto;
      margin-top: 0;
    }
  }
`

const StyleButton = styled.div`
  bottom: -30px;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
`

const GravityForm = ({ contact, normalThanks, thanks, preview, id, perColumn }) => {
  const { allGfForm: { edges: gravityData } } = useStaticQuery(graphql`
    query {
      allGfForm {
        edges {
          node {
            formId
            slug
            apiURL
            descriptionPlacement
            formFields {
              id
              label
              labelPlacement
              description
              descriptionPlacement
              type
              choices
              content
              errorMessage
              inputMaskValue
              isRequired
              visibility
              cssClass
              placeholder
              size
              defaultValue
              maxLength
            }
            button {
              text
            }
            confirmations {
              message
            }
          }
        }
      }
    }
  `)

  const { node: gfForm } = gravityData.filter(({ node }) => node.formId === id)[0];

  const [fields, setFields] = useState({});
  const [form, setForm] = useState(gfForm);
  const [status, setStatus] = useState('');
  const [message, setMessage] = useState('');

  useEffect(() => {
    let tempForm = form;

    // add submit button as a field
    if (tempForm.formFields.filter((item) => item.type === "submit").length === 0)  {
      tempForm.formFields = [
        ...tempForm.formFields,
        {
          formId: v4(),
          type: "submit",
          text: tempForm.button.text
        }
      ];
    }

    if (perColumn) {
      tempForm = {
        ...tempForm,
        formFields: chunkArray(tempForm.formFields, perColumn)
      };
    }

    setForm({
      ...form,
      ...tempForm
    });
  }, [])

  async function handleOnSubmit(event) {
    console.log('Submitting')
    event.preventDefault();

    if (status === 'processing') {
      return;
    }

    setStatus('processing');

    try {
      const formData = new FormData();

      const date = fields.input_12

      for (const [key, value] of Object.entries(fields)) {
        let val = value

        if (key === "input_12") {
          val = `${(date.getMonth() > 8) ? (date.getMonth() + 1) : (`0${  date.getMonth() + 1}`)  }/${  (date.getDate() > 9) ? date.getDate() : (`0${  date.getDate()}`)  }/${  date.getFullYear()}`
        }

        formData.append(key, val);
      }

      const request = await fetch(`${form.apiURL}/submissions`, {
        method: 'POST',
        body: formData
      });

      const response = await request.json();
      if (response.is_valid === true) {
        setStatus('done');

        setMessage(response.confirmation_message);

        if (preview) {
          navigate('/bedankt-offerte-aanvragen');
        }

        if (contact) {
          navigate('/bedankt-contact')
        }
      } else {
        setStatus('error');
        console.log(response);
      }
    } catch (error) {
      setStatus('error');
      console.error(error);
    }
  }

  const isDate = (date) => {
    return (new Date(date) !== "Invalid Date") && !isNaN(new Date(date))
  }

  function handleFieldChange(event) {
    // eslint-disable-next-line prefer-destructuring

    if (isDate(event)) {
      setFields({
        ...fields,
        input_12: event
      })
    } else {
      let {value} = event.target || event.value;

      if (event.target) {
        if (event.target.type === "checkbox") {
          value = event.target.checked ? event.target.value : "";
          setFields({
            ...fields,
            [event.target.id]: value
          });
        } else if (event.target.type === "radio") {
          value = event.target.checked ? event.target.value : "";
          
          if (fields.input_5_1) {
            delete fields.input_5_1
          }

          if (fields.input_5_2) {
            delete fields.input_5_2
          }

          setFields({
            ...fields,
            [event.target.id]: value
          });
        } else {
          setFields({
            ...fields,
            [event.target.id]: value
          })
        }
        
      } else {
        setFields({
          ...fields,
          [event.name]: event.value
        })
      }
    }
  }

  if (form.formFields) {
    const testList = []

    _.map(fields, (field, key) => {
      if (field !== "") {
        switch (parseInt(key.split('_')[1])) {
          case 2:
            if (testList['kenteken']) {
              testList['kenteken'].push(field)
            } else {
              testList['kenteken'] = [field]
            }
            break
          case 3:
            if (testList['werkzaamheden']) {
              testList['werkzaamheden'].push(field)
            } else {
              testList['werkzaamheden'] = [field]
            }
            break
          case 4:
            if (testList['werkzaamheden']) {
              testList['werkzaamheden'].push(field)
            } else {
              testList['werkzaamheden'] = [field]
            }
            break
          case 5:
            testList["geslacht"] = field
            break
          case 6:
            testList["achternaam"] = field
            break
          case 9:
            testList["telefoonnummer"] = field
            break
          case 10:
            testList["email"] = field
            break
          case 12:
            testList["datum"] = field
            break
          case 14:
            testList["opmerkingen"] = field
            break
        }
      } else {
        return false
      }
    })

    return (
      <Form method="post" className={`form_${form.formId}`} onSubmit={handleOnSubmit}>
        {normalThanks ? (
          <>
            <P className="font-size-m pt-4 font-weight-xl">Dank u wel voor het invoeren van het formulier, wij komen zo snel mogelijk met u in contact.</P>
          </>
        ) : (
          <>
            {thanks ? (
              <div className="row">
                <div className="col-12 col-lg-8">
                  <div className="row">
                    {form.formFields && form.formFields.map((field, key) => {
                      let classes = "";
                      if (field.label === "Achternaam") {
                        classes = `col-lg-4 pt-3`
                      } else if (field.label === "Uw gegevens") {
                        classes = `col-lg-3`
                      } else if (field.label === "Werkzaamheden") {
                        classes = `col-lg-12`
                      } else if (field.label === "Onderdelen vervangen") {
                        classes = `col-lg-12`
                      } else {
                        classes = `col-lg-7`
                      }
    
                      if (field.type !== 'submit') {
                        if (Array.isArray(field)) {
                          return (
                            <div key={key} className={`col-lg-${calculateColumn(form.formFields.length)}`}>
                              {field.map((item, index) => (
                                <FormField key={index} field={item} fields={fields} onChange={handleFieldChange} />
                              ))}
                            </div>
                          )
                        }
    
                        return (
                          <div key={key} className={classes}>
                            <FormField key={key} field={field} fields={fields} onChange={handleFieldChange} />
                          </div>
                        )
                      } else {
                        return true;
                      }
                    })}
                  </div>
                </div>
                <div className="col-12 col-lg-4">
                  <Preview className={`position-relative color-background-secondary ${status === "done" ? `py-5 px-5` : `p-5`}`}>
                    {status === "processing" ? (
                      <Loading />
                    ) : (
                      <>
                        { status === "done" ? (
                          <Content>{parse(message)}</Content>
                        ) : (
                          <>
                            <H2 className="color-main font-weight-xl font-size-mxm">Bedankt voor uw aanvraag!</H2>
                            <P className="font-size-m pt-4 font-weight-xl">Uw offerte is in goede orde ontvangen. Wij nemen zo spoedig mogelijk contact met u op!</P>
                          </>
                        )}
                      </>
                    )}
                  </Preview>
                </div>
              </div>
            ) : (
              <>
                {preview ? (
                  <div className="row">
                    <div className="col-12 col-lg-8">
                      <div className="row">
                        {form.formFields && form.formFields.map((field, key) => {
                          let classes = "";
                          if (field.label === "Achternaam") {
                            classes = `col-lg-4 pt-3`
                          } else if (field.label === "Uw gegevens") {
                            classes = `col-lg-3`
                          } else if (field.label === "Werkzaamheden") {
                            classes = `col-lg-12`
                          } else if (field.label === "Onderdelen vervangen") {
                            classes = `col-lg-12`
                          } else {
                            classes = `col-lg-7`
                          }
        
                          if (field.type !== 'submit') {
                            if (Array.isArray(field)) {
                              return (
                                <div key={key} className={`col-lg-${calculateColumn(form.formFields.length)}`}>
                                  {field.map((item, index) => (
                                    <FormField key={index} field={item} fields={fields} onChange={handleFieldChange} />
                                  ))}
                                </div>
                              )
                            }
        
                            return (
                              <div key={key} className={classes}>
                                <FormField key={key} field={field} fields={fields} onChange={handleFieldChange} />
                              </div>
                            )
                          } else if ( status === "done" ) {
                              // Do nothing
                            } else {
                              if (Array.isArray(field)) {
                                return (
                                  <div key={key} className={`col-lg-${calculateColumn(form.formFields.length)}`}>
                                    {field.map((item, index) => (
                                      <FormField key={index} field={item} fields={fields} onChange={handleFieldChange} />
                                    ))}
                                  </div>
                                )
                              }
                              
                              return (
                                <div key={key} className={`${classes} d-none d-lg-block`}>
                                  <FormField key={key} field={field} fields={fields} onChange={handleFieldChange} />
                                </div>
                              )
                            }
                        })}
                      </div>
                    </div>
                    <div className="col-12 col-lg-4">
                      <Preview className={`position-relative color-background-secondary ${status === "done" ? `py-5 px-5` : `p-5`}`}>
                        {status === "processing" ? (
                          <Loading />
                        ) : (
                          <>
                            { status === "done" ? (
                              <Content>{parse(message)}</Content>
                            ) : (
                              <>
                                <H2 className="color-main font-weight-xl font-size-xm">Samenvatting</H2>
                                <H2 className="font-size-ms pt-4 font-weight-xl">Kenteken</H2>
                                {_.map(testList["kenteken"], (item, index) => (
                                  <P className="font-size-ms pl-3 text-uppercase" key={index}>{item}</P>
                                ))}
                                <H2 className="font-size-ms pt-4 font-weight-xl">Werkzaamheden</H2>
                                {_.map(testList["werkzaamheden"], (item, index) => (
                                  <P key={index}>
                                    <Image className="pr-2" src={blueCheck} alt="" />
                                    {item}
                                  </P>
                                ))}
                                <H2 className="font-size-ms pt-4 font-weight-xl">Gegevens</H2>
                                <P className="pl-3">{`${testList["geslacht"] !== undefined ? `${testList["geslacht"]}` : ``} ${testList["achternaam"] !== undefined ? `${testList["achternaam"]}` : ``}`}</P>
                                <P className="pl-3">{testList["telefoonnummer"] !== undefined ? `${testList["telefoonnummer"]}` : ``}</P>
                                <P className="pl-3">{testList["email"] !== undefined ? `${testList["email"]}` : ``}</P>
                                <H2 className="font-size-ms pt-4 font-weight-xl">Gewenste afspraak</H2>
                                <P className="pl-3 text-capitalize">{isDate(testList["datum"]) ? `${new Date(testList["datum"]).toLocaleDateString('nl-NL', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' })}` : ``}</P>
                                <H2 className="font-size-ms pt-4 font-weight-xl">Opmerkingen</H2>
                                <P className="pl-3">{testList["opmerkingen"] !== undefined ? `${testList["opmerkingen"]}` : ``}</P>
                
                                {form.formFields && _.map(form.formFields, (field, key) => {
                                  if (field.type === 'submit') {
                                    return (
                                      <StyleButton key={key} className="position-absolute">
                                        <FormField key={key} field={field} fields={fields} onChange={handleFieldChange} />
                                      </StyleButton>
                                    )
                                  }
                                })}
                              </>
                            )}
                          </>
                        )}
                      </Preview>
                    </div>
                  </div>
                ) : (
                  <>
                    {status === "processing" ? (
                      <Loading />
                    ) : ( 
                      <>
                        { status === "done" ? (
                          <Content>{parse(message)}</Content>
                        ) : (
                          <div className="row">
                            {form.formFields && form.formFields.map((field, key) => {
                              let classes = "";
                              if (field.label === "Achternaam" || field.label ==="Uw gegevens") {
                                classes = `col-lg-6`
                              } else {
                                classes = `col-lg-12`
                              }
        
                              if (Array.isArray(field)) {
                                return (
                                  <div key={key} className={`col-lg-${calculateColumn(form.formFields.length)}`}>
                                    {field.map((item, index) => (
                                      <FormField key={index} field={item} fields={fields} onChange={handleFieldChange} />
                                    ))}
                                  </div>
                                )
                              }
        
                              return (
                                <div className={classes}>
                                  <FormField key={key} field={field} fields={fields} onChange={handleFieldChange} />
                                </div>
                              )
                            })}
                          </div>
                        )}
                      </>
                    )}
                  </>
                )}
              </>
            ) }
          </>
        )}
      </Form>
    )
  }

  console.error("No gravity forms found with id", id);
  return false;
}

const TextField = ({ value, onChange, field: { id, type, label, labelPlacement, placeholder, isRequired, cssClass } }) => {

  if (cssClass === 'kentekenplaat') {
    return (
      <FormGroup>
        {labelPlacement !== "hidden_label" && <Label htmlFor={`input_${id}`}>{label}</Label>}
        <span className="kenteken-wrapper">
          <div className="inner-shadow" />
          <div className="blue-part">
            <img className="position-absolute" src={stars} alt="" />
            NL
          </div>
          <Input
            value={value}
            onChange={onChange}
            type="text"
            id={`input_${id}`}
            className={`${type} ${cssClass !== undefined ? cssClass : ""}`}
            name={`input_${id}`}
            required={isRequired}
            placeholder={placeholder}
          />
        </span>
      </FormGroup>
    )
  } 
    return (
      <FormGroup>
        {labelPlacement !== "hidden_label" && <Label htmlFor={`input_${id}`}>{label}</Label>}
        <Input
          value={value}
          onChange={onChange}
          type="text"
          id={`input_${id}`}
          className={`${type} ${cssClass !== undefined ? cssClass : ""}`}
          name={`input_${id}`}
          required={isRequired}
          placeholder={placeholder}
        />
      </FormGroup>
    )
  
}

const EmailField = ({ value, onChange, field: { id, type, label, labelPlacement, placeholder, isRequired, cssClass } }) => (
  <FormGroup>
    {labelPlacement !== "hidden_label" && <Label htmlFor={`input_${id}`}>{label}</Label>}
    <Input
      value={value}
      onChange={onChange}
      type="email"
      id={`input_${id}`}
      className={`${type} ${cssClass !== undefined ? cssClass : ""}`}
      name={`input_${id}`}
      required={isRequired}
      placeholder={placeholder}
    />
  </FormGroup>
)

const PhoneField = ({ value, onChange, field: { id, type, label, labelPlacement, placeholder, isRequired, cssClass } }) => (
  <FormGroup>
    {labelPlacement !== "hidden_label" && <Label htmlFor={`input_${id}`}>{label}</Label>}
    <Input
      value={value}
      onChange={onChange}
      type="tel"
      id={`input_${id}`}
      className={`${type} ${cssClass !== undefined ? cssClass : ""}`}
      name={`input_${id}`}
      required={isRequired}
      placeholder={placeholder}
    />
  </FormGroup>
)

const TextAreaField = ({ value, onChange, field: { id, type, label, labelPlacement, placeholder, isRequired, cssClass } }) => (
  <FormGroup>
    {labelPlacement !== "hidden_label" && <Label htmlFor={`input_${id}`}>{label}</Label>}
    <Textarea
      value={value}
      onChange={onChange}
      id={`input_${id}`}
      className={`${type} ${cssClass !== undefined ? cssClass : ""}`}
      name={`input_${id}`}
      required={isRequired}
      placeholder={placeholder}
    />
  </FormGroup>
)

const CheckboxField = ({ value, onChange, field: { id, type, label, labelPlacement, cssClass, choices } }) => {
  const list = JSON.parse(choices);

  let varBool;

  switch (label) {
    case "Werkzaamheden":
      varBool = true;
      break
    case "Onderdelen vervangen":
      varBool = false;
      break
    default:
      break
  }

  return (
    <FormGroup>
      {labelPlacement !== "hidden_label" && <Label htmlFor={`input_${id}`}>{label}</Label>}
      <div className="d-flex flex-wrap">
        {list.map((checkbox, key) => (
          <CheckBoxes boolCheck={varBool} key={key}>
            <Input
              checked={value}
              onChange={onChange}
              type="checkbox"
              id={`input_${id}_${key + 1}`}
              className={`${type} ${cssClass !== undefined ? cssClass : ""}`}
              name={`input_${id}_${key + 1}`}
              value={checkbox.value}
            />
            <Label htmlFor={`input_${id}_${key + 1}`} className="checkbox-content">{checkbox.text}</Label>
          </CheckBoxes>
        ))}
      </div>
    </FormGroup>
  )
}

const RadioField = ({ value, onChange, field: { id, type, label, labelPlacement, cssClass, choices } }) => {
  const list = JSON.parse(choices);

  return (
    <FormGroup>
      {labelPlacement !== "hidden_label" && <Label htmlFor={`input_${id}`}>{label}</Label>}
      <div className="d-flex flex-wrap">
        {list.map((radio, key) => (
          <RadioButtons key={key}>
            <Input
              checked={value}
              onChange={onChange}
              type="radio"
              id={`input_${id}_${key + 1}`}
              className={`${type} ${cssClass !== undefined ? cssClass : ""}`}
              name="geslacht"
              value={radio.value}
            />
            <Label htmlFor={`input_${id}_${key + 1}`} className="radio-content">{radio.text}</Label>
          </RadioButtons>
        ))}
      </div>
    </FormGroup>
  )
}

const DateField = ({ field, onChange, value}) => {

  const date = value

  return (
    <StyledDatePicker
      selected={date}
      onChange={onChange}
      minDate={new Date()}
      placeholderText={field.placeholder}
    />
  )
}

// Select or Dropdown
const SelectField = ({ field, onChange, value }) => {
  
  // Populate a options array
  const options = []
  _.each(JSON.parse(field.choices), choice => {
    options.push({
      value: choice.value,
      label: choice.text,
      type: 'select',
      name: `input_${field.id}`
    })
  })

  // Custom Select component
  const MySelect = props => (
    <Select
      {...props}
      onChange={props.onChange}
      options={props.options}
      placeholder={props.placeholder}
    />
  )

  return (
    <FormSelect>
      <MySelect 
        options={options}
        onChange={onChange}
        value={options.filter(option => option.value === value)}
        placeholder={field.label}
        classNamePrefix="react-select"
        className="react-select-container"
      />
    </FormSelect>
  )
}

const SubmitButton = ({ field }) => (
  <FormFooter>
    <FormButton className="color-background-contrast" type="submit">
      <P className="color-text-light font-weight-xl font-size-ms">{field.text}</P>
    </FormButton>
  </FormFooter>
)

const FileField = ({ value, onChange, field: { id, type, label, allowedExtensions, cssClass, placeholder } }) => {

  function handleChange(file) {
      onChange({
        target: {
          name: `input_${id}`,
          value: file
        }
      })
  }

  function handleFileUpload(e) {
    const { e: { target: { files } } } = e;

    for (let i = 0; i < files.length; i += 1) {
      handleChange(files[i])
    }
  }

  function handleFileDrop(e) {
    e.preventDefault();
    console.log(e);

    if (e.dataTransfer.items) {
      // Use DataTransferItemList interface to access the file(s)
      for (let i = 0; i < e.dataTransfer.items.length; i += 1) {
        // If dropped items aren't files, reject them
        if (e.dataTransfer.items[i].kind === 'file') {
          handleChange(e.dataTransfer.items[i].getAsFile());
        }
      }
    } else {
      // Use DataTransfer interface to access the file(s)
      for (let i = 0; i < e.dataTransfer.files.length; i += 1) {
        handleChange(e.dataTransfer.files[i]);
      }
    }
  }

  return (
    <FormUpload onDrop={handleFileDrop} onDragOver={e => e.preventDefault()}>
      <Label htmlFor={`input_${id}`}>
        {value ? (
          value.name
        ) : (
          <>{label}</>
        )}
      </Label>
      <Input
        type="file"
        onChange={handleFileUpload}
        id={`input_${id}`}
        className={`${type} ${cssClass !== undefined ? cssClass : ""}`}
        name={`input_${id}`}
        placeholder={placeholder}
        accept={allowedExtensions}
      />
    </FormUpload>
  )
}

export const FormField = ({ field, fields, onChange }) => (
  <>
    {field.type === "text" && <TextField onChange={onChange} value={fields[`input_${field.id}`]} field={field} />}
    {field.type === "email" && <EmailField onChange={onChange} value={fields[`input_${field.id}`]} field={field} />}
    {field.type === "phone" && <PhoneField onChange={onChange} value={fields[`input_${field.id}`]} field={field} />}
    {field.type === "textarea" && <TextAreaField onChange={onChange} value={fields[`input_${field.id}`]} field={field} />}
    {field.type === "checkbox" && <CheckboxField onChange={onChange} value={fields[`input_${field.id}`]} field={field} />}
    {field.type === "radio" && <RadioField onChange={onChange} value={fields[`input_${field.id}`]} field={field} />}
    {field.type === "select" && <SelectField onChange={onChange} value={fields[`input_${field.id}`]} field={field} />}
    {field.type === "fileupload" && <FileField onChange={onChange} value={fields[`input_${field.id}`]} field={field} />}
    {field.type === "date" && <DateField onChange={onChange} value={fields[`input_${field.id}`]} field={field} />}
    {field.type === "submit" && <SubmitButton field={field} />}
  </>
)

export const Loading = () => (
  <div className="form-loading">
    <div className="form-loading-spinner">
      <div className="sk-chase">
        <div className="sk-chase-dot" />
        <div className="sk-chase-dot" />
        <div className="sk-chase-dot" />
        <div className="sk-chase-dot" />
        <div className="sk-chase-dot" />
        <div className="sk-chase-dot" />
      </div>
    </div>
  </div>
);

export default GravityForm;


